import React from 'react';
import style from "./index.module.css";
import {Breadcrumb, Divider} from "antd";
import CertificateNavModule from "../../components/certificateNavModule";
import {useLocation, useNavigate} from "react-router-dom";
import NoticeModule from "../../components/noticeModule";
import NoticeArticle from "../../components/noticeArtice";

const FourthPage = () => {
    const locaton = useLocation();
    const navigate = useNavigate();
    let subPath = locaton?.state?.subPath;
    let articleId = locaton?.state?.articleId;

    const baseItem = [
        {
            title: <div>首页</div>,
        },
        {
            title: "信息中心",
        },
    ];

    switch (subPath) {
        case "c1":
            baseItem.push({
                title: "通知公告",
            });
            break;
        case "c2":
            baseItem.push({
                title: "行业动态",
            });
            break;
        case "c3":
            baseItem.push({
                title: "政策法规",
            });
            break;
        default:
            // 如果需要处理其他情况，可以加上 default 分支
            break;
    }
    return (
        <div className={style.pageContainer}>
            <Breadcrumb
                items={baseItem}
            />

            <div className={style.content}>
                <div className={style.leftNavBar}>
                    <div className={subPath === "c1" ? style.leftNavBarBtnPushed : style.leftNavBarBtn} onClick={() => {
                        navigate("/information", {state: {subPath: "c1"}})
                    }}>通知公告
                    </div>
                    <div className={subPath === "c2" ? style.leftNavBarBtnPushed : style.leftNavBarBtn} onClick={() => {
                        navigate("/information", {state: {subPath: "c2"}})
                    }}>行业动态
                    </div>
                    <div className={subPath === "c3" ? style.leftNavBarBtnPushed : style.leftNavBarBtn} onClick={() => {
                        navigate("/information", {state: {subPath: "c3"}})
                    }}>政策法规
                    </div>
                    <div style={{height: 60}}/>
                    <CertificateNavModule/>
                </div>

                <div className={style.rightMainContainer}>
                    <div>
                        <div className={style.pageTitle}>信息中心</div>
                        <Divider style={{padding: '0 30px', borderColor: '#043554'}}>INFORMATION CENTER</Divider>
                    </div>

                    <div className={style.articleContainer}>
                        {/*{subPath === "c1" ? (articleId ? <NoticeArticle subpath={subPath} articleId={articleId}/> : <NoticeModule type={subPath}/>)*/}
                        {/*    : subPath === "c2" ? (articleId ? <NoticeArticle subpath={subPath} articleId={articleId}/> : <NoticeModule type={subPath}/>)*/}
                        {/*        : subPath === "c3" ? (articleId ? <NoticeArticle subpath={subPath} articleId={articleId}/> : <NoticeModule type={subPath}/>)*/}
                        {/*            : (<div/>)}*/}

                        {articleId ?
                            <NoticeArticle subpath={subPath} articleId={articleId} /> :
                            <NoticeModule type={subPath} />}
                    </div>

                </div>
            </div>

        </div>
    );
};

export default FourthPage;